import { render, staticRenderFns } from "./authuser.vue?vue&type=template&id=05f1933d&"
import script from "./authuser.vue?vue&type=script&lang=ts&"
export * from "./authuser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports